import { inject, Injectable } from '@angular/core';
import {
    Auth,
    isSignInWithEmailLink,
    sendSignInLinkToEmail,
    signInWithEmailLink
} from '@angular/fire/auth';
import { StorageKey } from '@enums';
import { LOCAL_STORAGE, WINDOW } from 'moddy/common';

@Injectable({
    providedIn: 'root'
})
export class AuthEmailService {
    private readonly fireAuth = inject(Auth);
    private readonly window = inject(WINDOW);
    private readonly localStorage = inject(LOCAL_STORAGE);

    public async sendAuthLinkToEmail(email: string): Promise<unknown> {
        return sendSignInLinkToEmail(this.fireAuth, email, {
            url: `${this.window.location.origin}/finish-passwordless-sign-in`,
            handleCodeInApp: true
        }).then(() => {
            this.localStorage.setItem(StorageKey.EmailForSignIn, email);
        });
    }

    public async confirmEmail(): Promise<unknown> {
        if (isSignInWithEmailLink(this.fireAuth, this.window.location.href)) {
            let email = this.localStorage.getItem(StorageKey.EmailForSignIn);

            if (!email) {
                email = this.window.prompt(`Please enter your email address to confirm it:`);
            }

            return signInWithEmailLink(this.fireAuth, email!, this.window.location.href).then(() =>
                window.localStorage.removeItem(StorageKey.EmailForSignIn)
            );
        }

        throw new Error('Invalid redirect url');
    }
}
